/* global ga */
import t from 'tcomb';

export default function Google_Analytics() {}

Google_Analytics.prototype.track_pageview = function (name: t.String) {
  if (typeof ga !== 'undefined') {
    ga('send', 'pageview', name);
  }
};

Google_Analytics.prototype.track_event = function (category: t.String, action: t.String, label: t.String) {
  if (typeof ga !== 'undefined') {
    ga('send', 'event', category, action, label, 0);
  }
};



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/google_analytics.js
 **/